import { Networks, Address, Factory } from 'impermax-sdk';
import { useContext } from 'react';
import { NetworkContext } from '../contexts/Network';
import { chainDetailsMap } from '../utils/connections';
import { BLACKLISTED, WHITELISTED_OLD, WHITELISTED_PAIRS } from '../utils/constants';

export function useNetworkName() : Networks {
  const { networkName } = useContext(NetworkContext);
  return networkName as Networks;
}

export function useChainId() {
  const networkName = useNetworkName();
  return chainDetailsMap[networkName].networkId;
}

export function useNetworkCode() {
  const networkName = useNetworkName();
  const networkCode = 
    networkName === Networks.Mainnet ? "ethereum" : 
    networkName === Networks.Polygon ? "polygon" : networkName;
  return networkCode;
}

export function useNetworkHumanReadableName() {
  const networkName = useNetworkName();
  const networkHumanReadableName = 
    networkName === Networks.Mainnet ? "Ethereum" : 
    networkName === Networks.Arbitrum ? "Arbitrum" : 
    networkName === Networks.Avalanche ? "Avalanche" : 
    networkName === Networks.Moonriver ? "Moonriver" : 
    networkName === Networks.Moonbeam ? "Moonbeam" : 
    networkName === Networks.Fantom ? "Fantom" : 
    networkName === Networks.Cronos ? "Cronos" : 
    networkName === Networks.Harmony ? "Harmony" : 
    networkName === Networks.Aurora ? "Aurora" : 
    networkName === Networks.Sxnetwork ? "SX Network" : 
    networkName === Networks.Canto ? "Canto" : 
    networkName === Networks.ZksyncEra ? "ZkSync Era" : 
    networkName === Networks.Polygon ? "Polygon" :
    networkName === Networks.Mantle ? "Mantle" :
    networkName === Networks.Base ? "Base" :
    networkName === Networks.Optimism ? "Optimism" :
    networkName === Networks.Real ? "re.al" :
    networkName === Networks.Blast ? "Blast" :
    networkName === Networks.Scroll ? "Scroll" : 
    networkName === Networks.Linea ? "Linea" : 
    networkName === Networks.Sonic ? "Sonic" : networkName;
  return networkHumanReadableName;
}

export type PairsGetter = (factory: Factory) => Address[];

export function useGetWhitelistedPairs() : PairsGetter {
  const networkName = useNetworkName();
  return (factory: Factory) => {
    if (!WHITELISTED_PAIRS[networkName][factory]) return [];
    return WHITELISTED_PAIRS[networkName][factory].map((pair: Address) => pair.toLowerCase());
  }
}

export function useGetWhitelistedOld() : PairsGetter {
  const networkName = useNetworkName();
  return (factory: Factory) => {
    if (!WHITELISTED_OLD[networkName][factory]) return [];
    return WHITELISTED_OLD[networkName][factory].map((pair: Address) => pair.toLowerCase());
  }
}

export function useGetBlacklisted() : PairsGetter {
  const networkName = useNetworkName();
  return (factory: Factory) => {
    if (!BLACKLISTED[networkName][factory]) return [];
    return BLACKLISTED[networkName][factory].map((pair: Address) => pair.toLowerCase());
  }
}